// extracted by mini-css-extract-plugin
module.exports = {"bonusesContentWrap":"AdminBonusesComponent_bonusesContentWrap__1zHBX","radioWrap":"AdminBonusesComponent_radioWrap__3a3yV"};